
//Funcion para encontrar el ultimo Id de sesion que se encuentre en curso.
export const getLastIdSessionInCourse = (sessionsChatSelected, ) => {
    return sessionsChatSelected.reduceRight((ultimoEncontrado, elemento) => {
        // Si ya se encontró un elemento que cumple la condición, simplemente devuelve ese elemento
        if (ultimoEncontrado !== undefined) {
            return ultimoEncontrado
        };
        // Si el elemento cumple la condición, devuélvelo
        if (elemento.Fin === null) 
        {
            console.log("si se cumplio la condicion", elemento)
            return elemento;
        
        }  
          // Si no cumple la condición, continúa buscando
        return undefined;
    }, undefined); // Empieza con undefined como valor inicial
}
